import {CommonModule, registerLocaleData} from '@angular/common';
import localePt from '@angular/common/locales/pt';
import {APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {Router, RouterModule} from '@angular/router';
import {
  NgbActiveModal,
  NgbAlertModule,
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerModule,
  NgbModule,
  NgbPaginationModule,
} from '@ng-bootstrap/ng-bootstrap';
import {NgPreventCutCopyPasteModule} from 'ng-prevent-cut-copy-paste';
import {NgxMaskModule} from 'ngx-mask';
import {ToastrModule} from 'ngx-toastr';
import {AppRoutingModule} from './app-routing';
import {ComponentsModule} from './components/components.module';
import {httpInterceptorProviders} from './http-interceptors';

import '@angular/compiler';
import {BlockUIModule} from 'ng-block-ui';
import {defineLocale} from 'ngx-bootstrap/chronos';
import {ptBrLocale} from 'ngx-bootstrap/locale';
import {AppComponent} from './app.component';
import {BlockTemplateComponent} from './components/block-template/block-template/block-template.component';
import {AdminLayoutComponent} from './layouts/admin-layout/admin-layout.component';
import {AuthLayoutComponent} from './layouts/auth-layout/auth-layout.component';
import {ResetarSenhaComponent} from './pages/conta/resetar-senha/resetar-senha.component';
import {NotFoundComponent} from './pages/not-found/not-found.component';
import {TesteDeployComponent} from './pages/teste-deploy/teste-deploy.component';

import {ModalModule} from 'ngx-bootstrap/modal';

import {EinsteinConectaComponent} from './pages/modulos/portal/components/einstein-conecta/einstein-conecta.component';

import {AreaClienteComponent} from './pages/modulos/portal/components/area-cliente/area-cliente.component';
import {BlogComponent} from './pages/modulos/portal/components/blog/blog.component';
import {EmailContactComponent} from './pages/modulos/portal/components/email-contact/email-contact.component';
import {GeiaPortalComponent} from './pages/modulos/portal/components/geia-portal/geia-portal.component';
import {GeiaTeamComponent} from './pages/modulos/portal/components/geia-team/geia-team.component';
import {HeaderComponent} from './pages/modulos/portal/components/header/header.component';
import {HomeComponent} from './pages/modulos/Site/components/home/home.component';

import {LandingPageSegurosComponent} from './pages/modulos/landing-page/landing-page-seguros/landing-page-seguros.component';
import {AutoSliderBottomComponent} from './pages/modulos/portal/components/auto-slider-bottom/auto-slider-bottom.component';
import {ModalImpostoDeRendaComponent} from './pages/modulos/portal/components/modal-imposto-de-renda/modal-imposto-de-renda.component';
import {NexusChatComponent} from './pages/modulos/portal/components/nexus-chat/nexus-chat.component';
import {PortalFooterComponent} from './pages/modulos/portal/components/portal-footer/portal-footer.component';
import {SeguroCardPrecoComponent} from './pages/modulos/portal/components/seguros/seguro-card-preco/seguro-card-preco.component';
import {SegurosComponent} from './pages/modulos/portal/components/seguros/seguros.component';

import {JsonPipe} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatStepperModule} from '@angular/material/stepper';
import {NgSelectModule} from '@ng-select/ng-select';
import {BsDatepickerModule, BsLocaleService} from 'ngx-bootstrap/datepicker';
import {TagInputModule} from 'ngx-chips';
import {DecimalValuePipe} from './components/helper/pipes/decimal-value.pipe';
import {FormatNumberDecimalPipe} from './components/helper/pipes/formatar-numero.pipe';
import {CustomAdapter, CustomDateParserFormatter} from './components/helper/service/date/customDateParserFormatter';
import {PoliticaPrivacidadeComponent} from './pages/conta/politica-privacidade/politica-privacidade.component';
import {LandingPageSimuladorPrecoComponent} from './pages/modulos/landing-page/landing-page-simulador-preco/landing-page-simulador-preco.component';
import {BannerSimuladorPrecoComponent} from './pages/modulos/portal/components/banner-simulador-preco/banner-simulador-preco.component';
import {SimuladorPrecoComponent} from './pages/modulos/portal/components/simulador-preco/simulador-preco.component';
import {CarrosselComponent} from './pages/modulos/Site/components/carrossel/carrossel.component';
import {GrandesEPmeComponent} from './pages/modulos/Site/components/empresas/grandes-e-pme/grandes-e-pme.component';
import {PmeComponent} from './pages/modulos/Site/components/empresas/pme/pme.component';

import * as Sentry from '@sentry/angular';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {NgxSpinnerModule} from 'ngx-spinner';
import {AuthPropostaExternaGuard} from './guard/shared/auth-proposta-externa.guard';
import {PropostaExternaLayoutComponent} from './layouts/proposta-externa/proposta-externa-layout.component';
import {AcessoNegadoComponent} from './pages/acesso-negado/acesso-negado.component';
import {CardResultadoCotacaoComponent} from './pages/modulos/landing-page/card-resultado-cotacao/card-resultado-cotacao.component';
import {QuizEstiloDeVidaComponent} from './pages/modulos/quiz-estilo-de-vida/quiz-estilo-de-vida.component';
import {SharedModule} from './shared-module/shared/shared.module';
// PrimeNG
import {ButtonModule} from 'primeng/button';
import {EditorModule} from 'primeng/editor';
import {InputTextModule} from 'primeng/inputtext';
import {PaginatorModule} from 'primeng/paginator';
import {TableModule} from 'primeng/table';
import { QuizTesteVitalidadeComponent } from './pages/Modules/quiz-teste-vitalidade/quiz-teste-vitalidade.component';

defineLocale('pt-br', ptBrLocale);
registerLocaleData(localePt);

@NgModule({
  declarations: [
    HeaderComponent,
    AppComponent,
    AdminLayoutComponent,
    AuthLayoutComponent,
    ResetarSenhaComponent,
    NotFoundComponent,
    HomeComponent,
    HeaderComponent,
    PortalFooterComponent,
    EmailContactComponent,
    AreaClienteComponent,
    NexusChatComponent,
    BlogComponent,
    SegurosComponent,
    GeiaPortalComponent,
    GeiaTeamComponent,
    EinsteinConectaComponent,
    AutoSliderBottomComponent,
    SeguroCardPrecoComponent,
    ModalImpostoDeRendaComponent,
    LandingPageSegurosComponent,
    DecimalValuePipe,
    FormatNumberDecimalPipe,
    PoliticaPrivacidadeComponent,
    GrandesEPmeComponent,
    LandingPageSimuladorPrecoComponent,
    SimuladorPrecoComponent,
    BannerSimuladorPrecoComponent,
    PmeComponent,
    CarrosselComponent,
    CardResultadoCotacaoComponent,
    PropostaExternaLayoutComponent,
    QuizEstiloDeVidaComponent,
    AcessoNegadoComponent,
    TesteDeployComponent,
    QuizTesteVitalidadeComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    NgbModule,
    RouterModule,
    AppRoutingModule,
    ToastrModule.forRoot(),
    NgxMaskModule.forRoot(),
    BlockUIModule.forRoot({
      template: BlockTemplateComponent,
    }),
    NgbPaginationModule,
    NgbAlertModule,
    NgPreventCutCopyPasteModule,
    ModalModule.forRoot(),
    TagInputModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    NgSelectModule,
    BsDatepickerModule.forRoot(),
    HttpClientModule,
    NgbDatepickerModule,
    JsonPipe,
    PdfViewerModule,
    NgxSpinnerModule,
    EditorModule,
    // PrimeNG
    TableModule,
    ButtonModule,
    InputTextModule,
    PaginatorModule,

    CommonModule,
  ],

  providers: [
    AuthPropostaExternaGuard,
    httpInterceptorProviders,
    NgbActiveModal,
    {provide: NgbDateAdapter, useClass: CustomAdapter},
    {provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter},
    {provide: LOCALE_ID, useValue: 'pt-BR'},
    BsLocaleService,

    // Aqui começa o ajuste para o Sentry
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    // **ErrorHandler do Sentry para capturar erros globais**
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false, // Opcional, exibe um diálogo para o usuário ao capturar erro
      }),
    },
    //fim  sentry
  ],
})
export class AppModule {
  constructor(private localeService: BsLocaleService) {
    this.localeService.use('pt-br'); // Define a localidade para português
  }
}
